import { render, staticRenderFns } from "./Shared.vue?vue&type=template&id=2df30f6f"
import script from "./Shared.vue?vue&type=script&lang=ts"
export * from "./Shared.vue?vue&type=script&lang=ts"
import style0 from "./Shared.vue?vue&type=style&index=0&id=2df30f6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports